import {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './InlineArea.scss';

/**
 * This component is similar to the Area component, but intended to be in a compact space.
 * @param area
 * @returns {JSX.Element}
 * @constructor
 */
const InlineArea = ({ area }) => {
  function getAreaObj(areaToUse) {
    const hectares = areaToUse / 10_000;
    const isHectares = hectares >= 1;
    const value = isHectares ? hectares.toFixed(2) : areaToUse;
    return {
      value: value,
      unit: isHectares ? 'hectares' : 'meters',
      title: `${value} ${isHectares ? 'hectares' : 'square meters'}`
    };
  }

  const [areaObj, setAreaObj] = useState(() => getAreaObj(area));

  useEffect(() => setAreaObj(getAreaObj(area)), [area]);

  return (
    <div data-testid="InlineArea" className="InlineArea">
      {area ? (
        <Fragment>
          <div title={areaObj.title}>{areaObj.value}</div>
          <span
            dangerouslySetInnerHTML={{
              __html: 'meters' === areaObj.unit ? 'm<sup>2</sup>' : 'ha',
            }}
          />
        </Fragment>
      ) : (
        <span>-</span>
      )}
    </div>
  );
};

InlineArea.propTypes = {
  area: PropTypes.number,
};

InlineArea.defaultProps = {};

export default InlineArea;
